import { Button } from '@chakra-ui/react';
import styled from 'styled-components';

import { SubgroupColor } from '../../interfaces';

interface ContainerProps {
  rowHeight?: number;
  footer?: boolean;
  parentExpanded?: boolean;
  subLevelNumber: number;
  subgroupColor?: SubgroupColor;
  enableColumnsControls?: boolean;
}

interface ControlButtonProps {
  isActive: boolean;
}

export const ContainerTable = styled.table<ContainerProps>`
  width: ${({ footer }) => (footer ? 'max-content' : '100%')};
  min-width: 100%;
  max-width: ${({ footer }) => (footer ? 'none' : '100%')};
  display: flex;
  height: ${({ enableColumnsControls }) =>
    enableColumnsControls ? 'calc(100% - 35px * 2)' : '100%'};
  flex-direction: column;
  overflow-y: ${({ footer }) => (footer ? 'visible' : 'scroll')};
  scrollbar-width: ${({ footer }) => (footer ? 'auto' : 'none')};

  background-color: ${({
    parentExpanded,
    theme,
    subLevelNumber,
    subgroupColor,
  }) =>
    parentExpanded && subgroupColor?.active
      ? `${subgroupColor.color || theme.colors.black}${subLevelNumber * 10}`
      : 'transparent'};

  .ComumList {
    background-color: #ffffff;
  }
`;

export const Thead = styled.thead<{ headerIsAbsolute: boolean }>`
  position: ${({ headerIsAbsolute }) =>
    headerIsAbsolute ? 'sticky' : 'initial'};
  top: ${({ headerIsAbsolute }) => (headerIsAbsolute ? 0 : 'auto')};
  z-index: ${({ headerIsAbsolute }) => (headerIsAbsolute ? 2 : 'auto')};
  width: max-content;
  min-width: 100%;
  :last-child {
    border-right: 0;
  }
`;

export const TFooter = styled.tfoot<{ rowHeight: number }>`
  display: flex;
  flex: 1;
  align-items: flex-end;
  width: max-content;
  min-width: 100%;
  :last-child {
    border-right: 0;
  }
  align-self: flex-end;

  & .innerFooter {
    display: flex;
    flex: 1;
  }
`;

export const Tbody = styled.tbody`
  margin: 0;
  width: max-content;
  min-width: 100%;

  :last-child {
    border-right: 0;
  }

  .VirtualizedList {
    ::-webkit-scrollbar {
      width: 4px;
    }
  }
`;

export const ColumnsControlsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  width: max-content;
  margin: 1rem 0px;

  height: 35px;
`;

export const ControlButton = styled.button<ControlButtonProps>`
  padding: 4px 6px;
  border-radius: 4px;
  margin: 0px 4px;

  color: ${({ theme, isActive }) =>
    isActive ? theme.colors.lighterText : theme.colors.darkerText};

  background-color: ${({ theme, isActive }) =>
    isActive ? theme.colors.primary : 'transparent'};
  border: 1px solid ${({ theme }) => theme.colors.primary};
`;
